// extracted by mini-css-extract-plugin
export default {"checkedByContainer":"style_checkedByContainer__DSX82","checkedByText":"style_checkedByText__30wX7","logos":"style_logos__2pzG1","originalityLogo":"style_originalityLogo__rkb7Z"};